export { default as ImageHtml } from './component';
